import * as React from 'react';
import type { SVGProps } from 'react';

const IconForum = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path
      d="M0 0v16h12.8l3.2-3.2V0H0Zm15.2 12H12v3.199H.8v-12h14.401L15.2 12Z"
      fill="currentColor"
    />
    <path
      d="M2.4 5.6h11.2v.8H2.4v-.8ZM2.4 8.8h11.2v.8H2.4v-.8ZM2.4 12h8v.8h-8V12Z"
      fill="currentColor"
    />
  </svg>
);
export default IconForum;
